import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/env';

@Injectable({
  providedIn: 'root'
})
export class EmailUpdateService {
 private apiUrl = environment.BASE_URL + `/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } }

  constructor(private http: HttpClient) { }

  updateEmail(emailData: any) {
    return this.http.post(`${this.apiUrl}api/spp/profile-merge`, emailData, this.header);
  }

  getProfileUpdateStatus(userid: any){
    return this.http.get<any[]>(`${this.apiUrl}api/spp/profile-merge/user/${userid}`, this.header);
  }
}
